import { MdOutlineClose } from "react-icons/md";
import { useState, useEffect } from "react";

type THintPopover = {
    message: string;
    icon: React.ReactNode;
    onClose: () => void;
    left?: string;
}

const HintPopover = ({ message, icon, onClose, left = "md:left-12 xl:left-24" }: THintPopover) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 10);
        return () => clearTimeout(t);
    }, []);

    const handleClose = () => {
        setVisible(false);
        setTimeout(onClose, 300);
    };

    return (
        <div className={`relative md:absolute bottom-[calc(100%+0.75rem)] ${left} md:z-50 transition-all duration-300 max-w-[24.5rem]
            ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}
        >
            <div className="bg-brand-green-8 shadow-custom-dual rounded-sm p-4 flex items-start justify-between gap-3">
                <div className="flex gap-4">
                    {icon}
                    <p className="text-blarge text-system-dark-10 w-full">{message}</p>
                </div>
                <button onClick={handleClose}>
                    <MdOutlineClose size={20} />
                </button>
            </div>
            <div className="w-4 h-4 bg-brand-green-8 rotate-45 ml-12 md:ml-20 mt-[-0.5rem]" />
        </div>
    )
}

export default HintPopover